import { UserEntityPermissionsNames } from 'types/embedded/userEntityPermission';

export const USER_ENTITY_PERMISSIONS_RESOURCES = {
  [UserEntityPermissionsNames.Gateway]: 'gateways',
  [UserEntityPermissionsNames.MerchantAccount]: 'merchant_accounts',
  [UserEntityPermissionsNames.MerchantCredentials]: 'merchant_credentials',
};
